const { parquetReadObjects } = await import("hyparquet");
const CACHE_NAME = "geojson-v2.11";

export async function fetchCached(url) {
  const cache = await caches.open(CACHE_NAME);
  const cached = await cache.match(url);
  if (cached) return cached.json();

  const response = await fetch(url);
  await cache.put(url, response.clone());
  return response.json();
}

export async function fetchCachedParquet(url) {
  const cache = await caches.open(CACHE_NAME);
  let response = await cache.match(url);
  if (!response) {
    response = await fetch(url);
    await cache.put(url, response.clone());
  }

  const buffer = await response.arrayBuffer();
  const file = {
    byteLength: buffer.byteLength,
    slice: (start, end) => buffer.slice(start, end),
  };
  return parquetReadObjects({ file });
}
